import { Box, Container, Typography, Paper } from '@mui/material';

const CareersPage = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Typography 
          variant="h2" 
          component="h1" 
          align="center" 
          gutterBottom
          sx={{ 
            fontWeight: 700, 
            mb: 4,
            fontSize: { xs: '2rem', md: '2.5rem' }
          }}
        >
          Current Openings
        </Typography>
        
        <Typography 
          variant="subtitle1" 
          align="center" 
          sx={{ mb: 6, maxWidth: '800px', mx: 'auto' }}
        >
          Explore exciting career opportunities currently available through Recruitment Intelligence. We're looking for talented individuals to fulfill these client requisitions
        </Typography>
        
        <Paper 
          // elevation={3} 
          sx={{ 
            width: '100%', 
            height: '800px', 
            overflow: 'hidden',
            borderRadius: 0,
            boxshadow: 'none',
            mb: 4
          }}
        >
          <Box 
            component="iframe" 
            src="https://www2.jobdiva.com/portal/?a=1ujdnwrj39gls9ed4gpig5qubccjya0667r01d9ye4g9h6pns1hg6zcttrtk1l33#/"
            title="Recruitment Intelligence Careers" 
            sx={{ 
              width: '100%', 
              height: '100%', 
              border: 'none' 
            }} 
          />
        </Paper>
        
        <Typography variant="body2" align="center" sx={{ mt: 2, color: 'text.secondary' }}>
          Can't find what you're looking for? Email us at <Box component="span" sx={{ color: 'primary.main' }}>careers@recruitmentintelligence.com</Box>
        </Typography>
      </Container>
    </Box>
  );
};

export default CareersPage;
